module.exports = __webpack_public_path__ + "67dc7521a5666bb763ccbc0995882bc9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TJ.svg
// module id = jXEi
// module chunks = 0